import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export type Progress = {
    current : number;
    total : number;
};

type Props = {
    progress : Progress | null;
};

const ProgressBackdrop : React.FC<Props> = ({progress} : Props) => {
    const classes = useStyles();

    return (
        <Backdrop open={Boolean(progress)} className={classes.root}>
            <CircularProgress
                variant={progress?.current === 0 ? 'indeterminate' : 'determinate'}
                color="secondary"
                value={progress ? progress.current / progress.total * 100 : 0}
            />
        </Backdrop>
    );
};

export default ProgressBackdrop;
